export enum Consumed {
    Waiting = 0, // The payment hasn't been saved to RMS database yet for processing.
    Imported = 1, // The payment has been imported by the RMS but hasn't been posted.
    Posted = 2, // The payment has been posted and is reflected in the contract.
    Error = 3 // Unable to process the payment.
}
